// Shared by editors, navigation and deployment updates. Approval only applies
// to the exact draft revision the user saw; a later edit requires a new choice.
const workspaces = new Map();

export function registerWorkspaceGuard(key, state) {
  const previous = workspaces.get(key);
  const entry = { ...state, approved: previous?.revision === state.revision && previous?.approved };
  workspaces.set(key, entry);
  return () => {
    if (workspaces.get(key) === entry) workspaces.delete(key);
  };
}

export function clearWorkspaceGuard(key) {
  workspaces.delete(key);
}

export function hasPendingWorkspaceChanges() {
  return [...workspaces.values()].some(({ dirty, busy }) => dirty || busy);
}

export function confirmWorkspaceLeave(key) {
  const entries = key ? [workspaces.get(key)].filter(Boolean) : [...workspaces.values()];
  if (entries.some(({ busy }) => busy)) {
    window.alert('Please wait for the current save or delete to finish before leaving.');
    return false;
  }
  const pending = entries.filter(({ dirty, approved }) => dirty && !approved);
  if (!pending.length) return true;
  const names = pending.map(({ label }) => label).join(', ');
  if (!window.confirm(`You have unsaved changes in ${names}.\n\nChoose Cancel to keep editing and save your work, or OK to discard these changes and continue.`)) return false;
  pending.forEach((entry) => { entry.approved = true; });
  return true;
}

export function protectWorkspaceUnload(event) {
  if (!hasPendingWorkspaceChanges()) return;
  event.preventDefault();
  event.returnValue = '';
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', protectWorkspaceUnload);
}
